import React, { FC, useContext } from 'react';
import _find from 'lodash/find';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import styled from 'styled-components';
import Icon from '@minecraft.icon';
import SearchWithDropdownContext from '../SearchWithDropdownContext';

const StyledDropdownToggle = styled(DropdownToggle)`
  color: ${(props) => props.theme.colors.primary.darkGrey};
  background-color: ${(props) => props.theme.colors.primary.ltGrey1} !important;

  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-left: 0.25rem;
  padding-right: 0.25rem;

  height: 2rem;
  min-width: 2.5rem;

  border-color: ${(props) => props.theme.colors.primary.ltGrey1};
  border-radius: 4px 0 0 4px;

  &:hover,
  &:active,
  &:not(:disabled):not(.disabled):active,
  &.btn-secondary.dropdown-toggle,
  &:not(:disabled):not(.disabled):active:focus,
  &.btn-secondary.dropdown-toggle:focus,
  &:focus {
    box-shadow: none;
    color: ${(props) => props.theme.colors.primary.darkGrey};
    background-color: ${(props) => props.theme.colors.primary.white};
    border-color: ${(props) => props.theme.colors.primary.ltGrey1};
  }

  &:after {
    content: none;
  }
`;

const DropdownText = styled.span`
  font-size: 0.875rem;
`;

const CaretIcon = styled(Icon)`
  flex-shrink: 0;
  margin-left: 0.25rem;
  height: 0.75rem;
  width: 0.75rem;
`;

const getDropdownText = (selectedOptions, allOptions) => {
  if (selectedOptions.length === 1 && allOptions.length >= 1) {
    return _find(allOptions, { value: selectedOptions[0] }).label;
  }

  return '';
};

const Dropdown: FC = ({ children }) => {
  const { selectedOptions, allOptions } = useContext(SearchWithDropdownContext);
  const dropdownText = getDropdownText(selectedOptions, allOptions);

  return (
    <UncontrolledDropdown>
      <StyledDropdownToggle data-qa-id="search-dropdown-select-button" caret>
        {dropdownText && <DropdownText>{dropdownText}</DropdownText>}
        <CaretIcon name="caret-1" />
      </StyledDropdownToggle>
      <DropdownMenu>{children}</DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default Dropdown;
